<nav
  class="bg-white-background nav-bar-height dark:bg-theme-blue z-20 fixed w-full"
>
  <div
    class="mx-auto w-full px-2 pt-4 pb-4 w-full h-full tablet-min:px-6 laptop-min:px-8"
  >
    <div
      class="relative flex flex-row gap-2 w-full h-full items-center justify-center"
    >
      <div class="inset-y-0 left-0 flex items-center tablet-min:hidden">
        <!-- Mobile menu button-->
        <button
          type="button"
          (click)="toggleMenu()"
          id="mobile-menu-button"
          class="relative inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-300 focus:outline-none"
          aria-controls="mobile-menu"
          aria-expanded="false"
        >
          <span class="sr-only">Open main menu</span>

          <mat-icon
            aria-hidden="false"
            aria-label="menu burger"
            fontIcon="menu"
          ></mat-icon>
        </button>
      </div>
      <div
        class="sdf flex flex-1 items-center justify-center tablet-max:items-xxstretch tablet-min:justify-start"
      >
        <!-- <div class="flex flex-shrink-0 items-center justify-center"> -->
        <a
          routerLink="app/lots"
          class="zmy-2"
          class="hidden mobile-min:inline-block"
        >
          <img
            [ngSrc]="
              isLightMode()
                ? '../../../assets/icons/logo-j-connected_blue_2.png'
                : '../../../assets/icons/logo-j-connected_white.png'
            "
            height="79"
            width="190"
            alt="Johnston's Connected"
            priority
          />
        </a>
        <!-- </div> -->
        <div class="hidden tablet-min:ml-6 tablet-min:block">
          <div class="flex space-x-4 items-center">
            <a
              routerLink="app/lots"
              routerLinkActive="bg-custom-orange text-white "
              [ngClass]="{
                ' hover:bg-custom-orange  hover:text-white': feature !== 'lots'
              }"
              class="rounded-md px-3 py-2 text-sm font-medium"
              [attr.aria-current]="feature === 'lots' ? 'page' : null"
              (click)="onSelect('lots')"
              >Bids & Offers</a
            >
            <a
              routerLink="app/trades"
              [ngClass]="{
                'bg-custom-orange text-white': feature === 'trades',
                ' hover:bg-custom-orange  hover:text-white':
                  feature !== 'trades'
              }"
              class="rounded-md px-3 py-2 text-sm font-medium"
              [attr.aria-current]="feature === 'trades' ? 'page' : null"
              (click)="onSelect('trades')"
              >Trades</a
            >
            <a
              *appBlockUserRoles="['viewer']"
              routerLink="app/negotiations"
              [ngClass]="{
                'bg-custom-orange text-white': feature === 'negotiations',
                ' hover:bg-custom-orange  hover:text-white':
                  feature !== 'negotiations'
              }"
              class="rounded-md px-3 py-2 text-sm font-medium"
              [matBadge]="negotiations()"
              [matBadgeHidden]="!negotiations()"
              matBadgeDescription="Indicates how many negotiations the user has"
              matBadgeOverlap="false"
              matBadgeSize="large"
              [matBadgeOverlap]="true"
              matBadgePosition="above"
              [attr.aria-current]="feature === 'negotiations' ? 'page' : null"
              (click)="onSelect('negotiations')"
              >Negotiations
            </a>
            <!-- <a
                      routerLink="/chat"
              [ngClass]="{
                'bg-custom-orange text-white': feature === 'chat',
                ' hover:bg-custom-orange  hover:text-white':
                  feature !== 'chat'
              }"
                      class="rounded-md px-3 py-2 text-sm font-medium"
                      [attr.aria-current]="feature === 'chat' ? 'page' : null"
                      (click)="onSelect('chat')"
                      >Chat</a -->

            <a
              routerLink="app/contracts"
              [ngClass]="{
                'bg-custom-orange text-white': feature === 'contracts',
                ' hover:bg-custom-orange  hover:text-white':
                  feature !== 'contracts'
              }"
              class="rounded-md px-3 py-2 text-sm font-medium"
              [attr.aria-current]="feature === 'contracts' ? 'page' : null"
              (click)="onSelect('contracts')"
            >
              Contracts
            </a>
            <a
              matBadge="1"
              [matBadgeHidden]="wordPressService.readDaily()"
              matBadgeOverlap="false"
              matBadgeColor="accent"
              matBadgeSize="medium"
              [matBadgeOverlap]="true"
              matBadgePosition="above"
              routerLink="app/johnstons-daily"
              routerLinkActive="bg-custom-orange text-white  "
              class="rounded-md px-3 py-2 text-sm font-medium hover:bg-custom-orange hover:text-white"
              [attr.aria-current]="feature === 'faqs' ? 'page' : null"
              (click)="onSelect('johnstons-daily')"
            >
              Johnston's Daily
            </a>
            <a
              routerLink="app/faqs"
              routerLinkActive="bg-custom-orange text-white  "
              class="rounded-md px-3 py-2 text-sm font-medium hover:bg-custom-orange hover:text-white"
              [attr.aria-current]="feature === 'faqs' ? 'page' : null"
              (click)="onSelect('faqs')"
            >
              Help
            </a>
            @if (!isProd) {
            <div class="text-2xl" style="color: lightcoral !important">
              ***DEV***
            </div>
            }
          </div>
        </div>
      </div>
      <div
        class="hover:cursor-pointer dark:hover:bg-gray-800 hover:bg-gray-300 rounded-md p-2 m-2"
        (click)="themeService.toggle()"
      >
        @if(isLightMode()){
        <fa-icon
          aria-label="Button that displays a tooltip when focused or hovered over"
          matTooltip="Toggle Dark/Light mode"
          [icon]="faSun"
          size="lg"
          [style]="{ color: '#09203f', padding: '5px' }"
        ></fa-icon>
        }@else {
        <fa-icon
          aria-label="Button that displays a tooltip when focused or hovered over"
          matTooltip="Toggle Dark/Light mode"
          [icon]="faMoon"
          size="lg"
          [style]="{ padding: '5px' }"
        ></fa-icon>
        }
      </div>

      <div class="text-sm text-wrap">
        <div [matMenuTriggerFor]="menu" class="hover:cursor-pointer">
          Get the mobile app
          <mat-menu #menu="matMenu">
            <a
              class="hover:cursor-pointer"
              target="_blank"
              [href]="links.iosApp"
              mat-menu-item
              >iOS App</a
            >
            <a
              class="hover:cursor-pointer"
              target="_blank"
              [href]="links.androidApp"
              mat-menu-item
              >Android App</a
            >
          </mat-menu>
        </div>
      </div>
      @if (market$ | async; as market) { @if (showActiveMarket()) {
      <mat-form-field style="height: 3em">
        <mat-label>Market</mat-label>
        <mat-select
          [value]="market"
          (selectionChange)="changeMarket($event.value)"
        >
          @for (mark of userMarkets(); track mark) {
          <mat-option [value]="mark">
            @switch(mark){ @case ('Farm'){ FOB Farm } @case('Feed'){DOMESTIC}
            @default {
            {{ mark | uppercase }}
            } }</mat-option
          >
          }
        </mat-select>
      </mat-form-field>
      } }
      <div
        class="absolute inset-y-0 right-0 flex items-center pr-2 tablet-min:static tablet-min:inset-auto tablet-min:ml-6 tablet-min:pr-0"
      >
        <!-- notification bell (not used now) -->
        <!-- <button
          type="button"
          class="header-bg relative rounded-full p-1 text-gray-400 hover:text-custom-orange focus:outline-none focus:ring-0 focus:ring-offset-2 focus:ring-offset-custom-orange"
        >
          <span class="absolute -inset-1.5"></span>
          <span class="sr-only">View notifications</span>
          <svg
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            aria-hidden="true"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0"
            />
          </svg>
        </button> -->

        <!-- Profile dropdown -->
        <div
          class="relative ml-3 tablet-max:hidden"
          id="profile-dropdown"
          [class.open]="isProfileOpened"
        >
          <div class="rounded-full">
            <button
              type="button"
              (click)="toggleProfile()"
              class="relative inline-flex items-center justify-center w-10 h-10 overflow-hidden bg-gray-300 rounded-full dark:bg-gray-400 dark:text-white text-sm focus:outline-none focus:ring-0 focus:ring-offset-2 focus:ring-offset-custom-orange"
              id="user-menu-button"
              [attr.aria-expanded]="isProfileOpened"
              aria-haspopup="true"
            >
              <span class="absolute -inset-1.5"></span>
              <span class="sr-only">Open user menu</span>
              <span>{{ userInitials() | uppercase }} </span>
            </button>
          </div>

          @if (isProfileOpened) {
          <div
            id="profile-menu"
            [@dropdownAnimation]
            class="absolute right-0 bg-white-background dark:bg-custom-blue z-20 mt-2 w-48 origin-top-right rounded-md py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
            role="menu"
            aria-orientation="vertical"
            aria-labelledby="user-menu-button"
            tabindex="-1"
          >
            <!-- Active: "bg-gray-100", Not Active: "" -->
            <a
              matRipple
              routerLink="app/my-profile"
              class="block px-4 py-2 text-sm hover:bg-gray-200 dark:hover:bg-theme-blue"
              role="menuitem"
              tabindex="-1"
              id="user-menu-item-0"
              (click)="isProfileOpened = false"
              >My Profile</a
            >
            <!-- <a href="#" class="block px-4 py-2 text-sm text-gray-700" role="menuitem" tabindex="-1" id="user-menu-item-1">Settings</a> -->
            <a
              matRipple
              class="block px-4 py-2 text-sm cursor-pointer hover:bg-gray-200 dark:hover:bg-theme-blue"
              role="menuitem"
              tabindex="-1"
              id="user-menu-item-2"
              (click)="onLogout()"
              >Sign out</a
            >
          </div>
          }
        </div>
      </div>
    </div>
  </div>

  <!--burger Mobile menu, show/hide based on menu state. -->
  <div
    [ngClass]="{ hidden: !isMenuOpened, 'tablet-min:hidden': isMenuOpened }"
    [ngClass]="{ 'tablet-min:hidden': isMenuOpened, 'is-open': isMenuOpened }"
    class="bg-white-background dark:bg-custom-blue bg-white shadow-lg rounded-md menu-container"
    id="mobile-menu"
  >
    <div class="space-y-1 px-2 pb-3 pt-2">
      <a
        routerLink="app/lots"
        [ngClass]="{
          'bg-custom-orange text-white': feature === 'lots',
          ' hover:bg-custom-orange ': feature !== 'lots'
        }"
        class="block rounded-md px-3 py-2 text-base font-medium"
        [attr.aria-current]="feature === 'lots' ? 'page' : null"
        (click)="onSelect('lots')"
        >Bids & Offers</a
      >
      <a
        routerLink="app/trades"
        [ngClass]="{
          'bg-custom-orange text-white': feature === 'trades',
          ' hover:bg-custom-orange hover:text-white': feature !== 'trades'
        }"
        class="block rounded-md px-3 py-2 text-base font-medium"
        [attr.aria-current]="feature === 'trades' ? 'page' : null"
        (click)="onSelect('trades')"
        >Trades</a
      >
      <div
        routerLinkActive="bg-custom-orange text-white  "
        class="w-full hover:bg-custom-orange hover:text-white rounded-md"
      >
        <a
          *appBlockUserRoles="['viewer']"
          routerLink="app/negotiations"
          [ngClass]="{
            'bg-custom-orange text-white': feature === 'negotiations',
            ' hover:bg-custom-orange hover:text-white':
              feature !== 'negotiations'
          }"
          class="w-fit block rounded-md px-3 py-2 text-base font-medium hover:bg-custom-orange hover:text-white"
          [attr.aria-current]="feature === 'negotiations' ? 'page' : null"
          [matBadge]="negotiations()"
          [matBadgeHidden]="!negotiations()"
          matBadgeDescription="Indicates how many negotiations the user has"
          matBadgeOverlap="true"
          matBadgeSize="large"
          [matBadgeOverlap]="true"
          matBadgePosition="above"
          (click)="onSelect('negotiations')"
          >Negotiations</a
        >
      </div>

      <!-- <a
                                routerLink="/chat"
        [ngClass]="{
          'bg-custom-orange text-white': feature === 'chat',
          'text-black hover:bg-custom-orange hover:text-white':
            feature !== 'chat'
        }"
                                class="block rounded-md px-3 py-2 text-base font-medium"
                                [attr.aria-current]="feature === 'chat' ? 'page' : null"
                                (click)="onSelect('chat')"
                                >Chat</a -->
      <a
        routerLink="app/contracts"
        [ngClass]="{
          'bg-custom-orange text-white': feature === 'contracts',
          ' hover:bg-custom-orange hover:text-white': feature !== 'contracts'
        }"
        class="block rounded-md px-3 py-2 text-base font-medium"
        [attr.aria-current]="feature === 'contracts' ? 'page' : null"
        (click)="onSelect('contracts')"
        >Contracts</a
      >
      <div
        routerLinkActive="bg-custom-orange text-white  "
        class="w-full hover:bg-custom-orange hover:text-white rounded-md"
      >
        <a
          matBadge="1"
          [matBadgeHidden]="wordPressService.readDaily()"
          matBadgeOverlap="false"
          matBadgeColor="accent"
          matBadgeSize="medium"
          [matBadgeOverlap]="true"
          matBadgePosition="above"
          routerLink="app/johnstons-daily"
          class="w-2/5 block rounded-md px-3 py-2 text-base font-medium hover:bg-custom-orange hover:text-white"
          [attr.aria-current]="feature === 'faqs' ? 'page' : null"
          (click)="onSelect('johnstons-daily')"
        >
          Johnston's Daily
        </a>
      </div>
      <a
        routerLink="app/my-profile"
        [ngClass]="{
          'bg-custom-orange text-white': feature === 'my-profile',
          ' hover:bg-custom-orange  hover:text-white': feature !== 'my-profile'
        }"
        class="block rounded-md px-3 py-2 text-base font-medium"
        [attr.aria-current]="feature === 'contracts' ? 'page' : null"
        (click)="onSelect('my-profile')"
        >My Profile</a
      >
      <a
        routerLink="app/faqs"
        routerLinkActive="bg-custom-orange text-white  "
        class="block rounded-md px-3 py-2 text-base font-medium hover:bg-custom-orange hover:text-white"
        [attr.aria-current]="feature === 'faqs' ? 'page' : null"
        (click)="onSelect('faqs')"
      >
        Help
      </a>
      <a
        [ngClass]="{
          'bg-custom-orange text-white': feature === 'sign-out',
          ' hover:bg-custom-orange  hover:text-white': feature !== 'contracts'
        }"
        class="block rounded-md px-3 py-2 text-base font-medium hover:bg-custom-orange"
        (click)="onLogout()"
        >Sign Out</a
      >
    </div>
  </div>
</nav>
